export type NEWSLETTER_JOIN = "newsletter-join";
export type NEWSLETTER_UNSUBSCRIBE_FROM = "newsletter-unsubscribe-from";

export type COOKIE_INFO_MARK_AS_READ = "cookie-info-mark-as-read";
export type COOKIE_INFO_WAS_READ = "cookie-info-was-read";

export type USER_SIGN_UP = "user/sign-up";
export type USER_CREATE_ACCOUNT  = "user/create-account";
export type USER_LOGIN = "user/login";
export type USER_LOGIN_STATUS = "user/login-status";
export type USER_LOGOUT = "user/logout";
export type USER_REQUEST_PASSWORD_CHANGE = "user/request-password-change";
export type USER_CHANGE_PASSWORD = "user/change-password";
export type USER_REQUEST_DELETE = "user/request-delete";
export type USER_DELETE_ACCOUNT = "user/delete-account";
export type USER_DATA = "user/data";

export type CART_ADD_ITEM = "cart/add-item";
export type CART_REMOVE_ITEM = "cart/remove-item";
export type CART_LIST_ITEMS = "cart/list-items";
export type CART_HIDE_TO_CART_QUESTION = "cart/hide-to-cart-question";
export type CART_GET_HIDE_TO_CART_QUESTION = "cart/get-hide-to-cart-question";

export type API = "api";

export type PAGE_EVENT = "page-event";

export type PHPAdress = 
  NEWSLETTER_JOIN | 
  NEWSLETTER_UNSUBSCRIBE_FROM |

  COOKIE_INFO_MARK_AS_READ |
  COOKIE_INFO_WAS_READ |

  USER_SIGN_UP |
  USER_CREATE_ACCOUNT |
  USER_LOGIN |
  USER_LOGIN_STATUS |
  USER_LOGOUT |
  USER_REQUEST_PASSWORD_CHANGE |
  USER_CHANGE_PASSWORD |
  USER_REQUEST_DELETE |
  USER_DELETE_ACCOUNT |
  USER_DATA |

  CART_ADD_ITEM |
  CART_REMOVE_ITEM |
  CART_LIST_ITEMS |
  CART_HIDE_TO_CART_QUESTION |
  CART_GET_HIDE_TO_CART_QUESTION |

  PAGE_EVENT |
  

  API 

;

export class PHPAdresses
{
  static readonly NEWSLETTER_JOIN:NEWSLETTER_JOIN = "newsletter-join";
  static readonly NEWSLETTER_UNSUBSCRIBE_FROM:NEWSLETTER_UNSUBSCRIBE_FROM = "newsletter-unsubscribe-from";

  static readonly COOKIE_INFO_MARK_AS_READ:COOKIE_INFO_MARK_AS_READ = "cookie-info-mark-as-read";
  static readonly COOKIE_INFO_WAS_READ:COOKIE_INFO_WAS_READ = "cookie-info-was-read";

  static readonly USER_SIGN_UP:USER_SIGN_UP = "user/sign-up";
  static readonly USER_CREATE_ACCOUNT:USER_CREATE_ACCOUNT = "user/create-account";
  static readonly USER_LOGIN:USER_LOGIN = "user/login";
  static readonly USER_LOGIN_STATUS:USER_LOGIN_STATUS = "user/login-status";
  static readonly USER_LOGOUT:USER_LOGOUT = "user/logout";
  static readonly USER_REQUEST_PASSWORD_CHANGE:USER_REQUEST_PASSWORD_CHANGE = "user/request-password-change";
  static readonly USER_CHANGE_PASSWORD:USER_CHANGE_PASSWORD = "user/change-password";
  static readonly USER_REQUEST_DELETE:USER_REQUEST_DELETE = "user/request-delete";
  static readonly USER_DELETE_ACCOUNT:USER_DELETE_ACCOUNT = "user/delete-account";
  static readonly USER_DATA:USER_DATA = "user/data";

  static readonly CART_ADD_ITEM:CART_ADD_ITEM = "cart/add-item";
  static readonly CART_REMOVE_ITEM:CART_REMOVE_ITEM = "cart/remove-item";
  static readonly CART_LIST_ITEMS:CART_LIST_ITEMS = "cart/list-items";
  static readonly CART_HIDE_TO_CART_QUESTION:CART_HIDE_TO_CART_QUESTION = "cart/hide-to-cart-question";
  static readonly CART_GET_HIDE_TO_CART_QUESTION:CART_GET_HIDE_TO_CART_QUESTION =  "cart/get-hide-to-cart-question";

  static readonly PAGE_EVENT:PAGE_EVENT = "page-event";

  static readonly API:API = "api";
}
